import React, { createContext, useContext } from "react";

// Context to store the current radio index
interface RadioIndexContextType {
  currentIndex: number;
}

const RadioIndexContext = createContext<RadioIndexContextType | undefined>(
  undefined
);

// Hook to use the radio index in any child component
export const useRadioIndex = () => {
  const context = useContext(RadioIndexContext);
  if (!context) {
    throw new Error("useRadioIndex must be used within a RadioIndexProvider");
  }
  return context.currentIndex;
};

// Provider for each radio's index
interface RadioIndexProviderProps {
  index: number;
  children: React.ReactNode;
}

export const RadioIndexProvider: React.FC<RadioIndexProviderProps> = ({
  index,
  children,
}) => {
  return (
    <RadioIndexContext.Provider value={{ currentIndex: index }}>
      {children}
    </RadioIndexContext.Provider>
  );
};
